import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Configuration simplifiée
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'fr',
    debug: true, // Activez le debug temporairement
    resources: {
      en: {
        home: require('./locales/en/home.json'),
        create: require('./locales/en/create.json'),
        join: require('./locales/en/join.json'),
        chat: require('./locales/en/chat.json'),
        common: require('./locales/en/common.json'),
      },
      fr: {
        home: require('./locales/fr/home.json'),
        create: require('./locales/fr/create.json'),
        join: require('./locales/fr/join.json'),
        chat: require('./locales/fr/chat.json'),
        common: require('./locales/fr/common.json'),
      }
    },
    ns: ['home', 'create', 'join', 'chat'],
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false
    }
  });

export default i18n;